import React from "react";

import ScreenLayout from "../../layout/ScreenLayout/ScreenLayout";

import DialogForm from "../../components/DialogForm/DialogForm";

export default function DialogScreen() {
  return (
    <ScreenLayout>
      <DialogForm />
    </ScreenLayout>
  );
}
